import { ChangeEvent, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogContentText, TextField, Typography, makeStyles } from '@material-ui/core';
import { useUpdateCompany } from 'common/hooks/company/useUpdateCompany';
import { useNotifier } from 'common/hooks/useNotifier';
import Message from 'common/models/Message';

const styles = {
    btnCancel: {
        border: '1px solid #2b333f',
        color: '#2b333f',
        '&:active': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: '#eee !important',
            color: '#ccc !important',
        },
    },
    btnConfirm: {
        marginLeft: '5px',
    },
};

const useStyles = makeStyles(styles);

interface IEditCompanyDialog {
    open: boolean;
    id: number;
    name: string;
    close: () => void;
}

export const EditCompanyDialog = ({ open, id, name, close }: IEditCompanyDialog) => {
    const classes = useStyles();
    const [newName, setNewName] = useState(name);
    const { updateCompany } = useUpdateCompany();
    const [isUpdating, setIsUpdating] = useState(false);
    const { notify } = useNotifier();

    const handleNameChange = (event: ChangeEvent<any>) => {
        setNewName(event.target.value);
    };

    const handelUpdate = async () => {
        const trimmedName = newName.trim();

        if (trimmedName === '') {
            return;
        }

        setIsUpdating(true);

        try {
            await updateCompany({ id, name: trimmedName });
            setNewName('');
            close();
        } catch (error) {
            console.error(error);
            notify(new Message({ title: `Unable to edit company. ${error}`, type: 'error' }));
        }

        setIsUpdating(false);
    };

    return (
        <Dialog open={open} aria-labelledby="form-dialog-title">
            <DialogContent>
                <DialogContentText color="primary">
                    <Box p={1} style={{ width: '25vw' }}>
                        <Typography variant="h6">Edit Company</Typography>
                        <Box p={1}></Box>
                        <TextField fullWidth label="Name" variant="outlined" required={true} value={newName} onChange={handleNameChange} />
                        <Box p={1}></Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, m: 1, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                size="medium"
                                color="secondary"
                                onClick={() => {
                                    setNewName('');
                                    close();
                                }}
                                disabled={isUpdating}
                                className={classes.btnCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                autoFocus
                                variant="contained"
                                size="medium"
                                onClick={handelUpdate}
                                disabled={isUpdating}
                                className={classes.btnConfirm}
                            >
                                Update
                                {isUpdating ? (
                                    <>
                                        <Box sx={{ ml: 1, mr: 1 }}>
                                            <CircularProgress size={'0.8rem'} color="inherit" />
                                        </Box>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Button>
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};
